"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundAssetBucket = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./BackgroundAssetBucket.css"));
var inversify_react_1 = require("inversify-react");
var DragStore_1 = require("Project/Stores/DragStore/DragStore");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var VideoUtils_1 = require("@CommonFrontend/Utils/VideoUtils");
var BackgroundStyleManager_1 = require("./BackgroundStyleManager");
var BackgroundAssetBucket = function (_a) {
    var type = _a.type, size = _a.size, onClose = _a.onClose;
    var dragStore = (0, inversify_react_1.useInjection)("dragStore");
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var mediaUsageReporter = (0, inversify_react_1.useInjection)("mediaUsageReporter");
    var uploadStore = (0, inversify_react_1.useInjection)("uploadStore");
    var assetLibraryOverlay = (0, inversify_react_1.useInjection)("assetLibraryOverlay");
    var backgroundStyleManager = (0, inversify_react_1.useInjection)(BackgroundStyleManager_1.BackgroundStyleManager);
    var _b = __read((0, react_1.useState)(false), 2), canDrop = _b[0], setCanDrop = _b[1];
    var _c = __read((0, react_1.useState)(""), 2), embedInput = _c[0], setEmbedInput = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), showEmbedError = _d[0], setShowEmbedError = _d[1];
    var _e = __read((0, react_1.useState)(null), 2), uploadId = _e[0], setUploadId = _e[1];
    var fileInputRef = (0, react_1.useRef)(null);
    var embedButtonRef = (0, react_1.useRef)(null);
    var getDragAsset = function (event) {
        var _a;
        var sidebarImage = dragStore.findDragItemFromCurrentDrag(DragStore_1.DragType.SidebarImage);
        var sidebarVideo = dragStore.findDragItemFromCurrentDrag(DragStore_1.DragType.SidebarVideo);
        var isNativeImage = event.dataTransfer.items.length === 1 && ((_a = event.dataTransfer.items[0]) === null || _a === void 0 ? void 0 : _a.type.startsWith("image/"));
        if (type === "image" && !!sidebarImage) {
            return sidebarImage;
        }
        if (type === "video" && !!sidebarVideo) {
            return sidebarVideo;
        }
        if (type === "image" && isNativeImage) {
            return { type: "native", file: event.dataTransfer.files[0] };
        }
        return null;
    };
    var instructionalText = (0, react_1.useMemo)(function () {
        if (blockStore.isSavedBlock && type === "video") {
            return "Embed a background video";
        }
        return "Drag ".concat({ image: "an image", video: "a video" }[type], " here, or");
    }, [blockStore.isSavedBlock, type]);
    var handleDragOver = function (event) {
        if (!getDragAsset(event))
            return;
        setCanDrop(true);
        event.preventDefault();
    };
    var handleDragLeave = function () {
        setCanDrop(false);
    };
    var handleDrop = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var dragAsset;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setCanDrop(false);
                    dragAsset = getDragAsset(event);
                    if (!dragAsset)
                        return [2];
                    event.preventDefault();
                    if (!(dragAsset.type === "native")) return [3, 2];
                    (0, tiny_invariant_1.default)(!!dragAsset.file, "no file in native dragAsset");
                    return [4, uploadAndSetImage(dragAsset.file)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (dragAsset.type === DragStore_1.DragType.SidebarImage) {
                        backgroundStyleManager.setBackgroundProperties({
                            type: "image",
                            url: dragAsset.mediaData.url,
                        });
                        mediaUsageReporter.reportUsage(dragAsset.mediaSource, dragAsset.mediaData);
                    }
                    if (dragAsset.type === DragStore_1.DragType.SidebarVideo) {
                        backgroundStyleManager.setBackgroundProperties({
                            type: "video",
                            url: dragAsset.mediaData.url,
                            videoThumbnail: dragAsset.mediaData.thumbnailUrl,
                        });
                        mediaUsageReporter.reportUsage(dragAsset.mediaSource, dragAsset.mediaData);
                    }
                    return [2];
            }
        });
    }); };
    var handleFileUpload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var file;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!fileInputRef.current)
                        return [2];
                    if (!fileInputRef.current.files)
                        return [2];
                    file = fileInputRef.current.files[0];
                    return [4, uploadAndSetImage(file)];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var uploadAndSetImage = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var uploadId, upload, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    uploadId = uploadStore.upload(file);
                    setUploadId(uploadId);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4, uploadStore.waitForUpload(uploadId)];
                case 2:
                    upload = _b.sent();
                    (0, tiny_invariant_1.default)(!!upload.url, "no URL returned by upload");
                    backgroundStyleManager.setBackgroundProperties({
                        type: "image",
                        url: upload.url,
                    });
                    return [3, 4];
                case 3:
                    _a = _b.sent();
                    return [3, 4];
                case 4:
                    setUploadId(null);
                    return [2];
            }
        });
    }); };
    var handleEmbedClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var canonicalVideoUrl, _a, _b, err_1;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setShowEmbedError(false);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    canonicalVideoUrl = (0, VideoUtils_1.getCanonicalVideoUrl)(embedInput);
                    _b = (_a = backgroundStyleManager).setBackgroundProperties;
                    _c = {
                        type: "video",
                        url: canonicalVideoUrl
                    };
                    return [4, (0, VideoUtils_1.getVideoThumbnail)(canonicalVideoUrl)];
                case 2:
                    _b.apply(_a, [(_c.videoThumbnail = _d.sent(),
                            _c)]);
                    return [3, 4];
                case 3:
                    err_1 = _d.sent();
                    setShowEmbedError(true);
                    throw err_1;
                case 4: return [2];
            }
        });
    }); };
    var handleOpenImageLibrary = function () {
        assetLibraryOverlay.launchBasicOverlay(function (_mediaSource, dataObject) {
            backgroundStyleManager.setBackgroundProperties({
                type: "image",
                url: dataObject.url,
            });
        });
    };
    var isUploading = !!uploadId;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.bucket, padding: "m", gap: "s" },
        size === "standard" && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(kaleidoscope_1.IconButton, { className: styles.close, icon: react_1.default.createElement(icons_1.Close, null), type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Small, onClick: onClose }),
            react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s" },
                "Background ",
                type),
            react_1.default.createElement("div", { onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDrop },
                isUploading && (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.uploadSpinnerContainer, align: "center", justify: "center" },
                    react_1.default.createElement(kaleidoscope_1.Spinner, { message: "Uploading", size: "l" }))),
                !isUploading && (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.dropzone({ canDrop: canDrop }), gap: "s", align: "center", justify: "center" },
                    !canDrop && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(kaleidoscope_1.Text, { secondary: true, size: "s" }, instructionalText),
                        {
                            image: (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xxs" },
                                react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small, onClick: function () {
                                        var _a;
                                        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
                                    } },
                                    react_1.default.createElement(icons_1.Upload, null),
                                    " Upload",
                                    react_1.default.createElement("input", { type: "file", className: styles.fileInput, ref: fileInputRef, accept: "image/*", onChange: handleFileUpload, tabIndex: -1 })),
                                react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Popout, null), size: kaleidoscope_1.ButtonSize.Small, onClick: handleOpenImageLibrary }))),
                            video: (react_1.default.createElement(kaleidoscope_1.Popover, { autoStack: true, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small }, buttonProps),
                                    react_1.default.createElement(icons_1.Api, null),
                                    " Embed")); }, className: "nested-portal" },
                                react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m", align: "center" },
                                    react_1.default.createElement(kaleidoscope_1.TextInput, { autoFocus: true, label: "Link or embed code", labelHidden: true, placeholder: "Link or embed code", value: embedInput, onChange: function (value) {
                                            setEmbedInput(value);
                                        }, error: showEmbedError ? "Unable to embed video. Try again." : undefined, onKeyDown: function (event) {
                                            if (event.key === "Enter" && embedButtonRef.current) {
                                                embedButtonRef.current.click();
                                            }
                                        }, endElement: react_1.default.createElement(kaleidoscope_1.Button, { ref: embedButtonRef, className: styles.embedButton, size: kaleidoscope_1.ButtonSize.Small, onClick: handleEmbedClick }, "Embed") }),
                                    react_1.default.createElement("img", { src: "/Assets/Images/background-video-embed-logos.svg", width: 152, height: 26 })))),
                        }[type])),
                    canDrop && (react_1.default.createElement(kaleidoscope_1.Text, { className: styles.dropPromptText, size: "s" },
                        "Release to add ",
                        type))))))),
        size === "mini" && (react_1.default.createElement("div", { className: styles.miniBucketContainer, onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDrop },
            isUploading && (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.uploadSpinnerContainer, align: "center", justify: "center" },
                react_1.default.createElement(kaleidoscope_1.Spinner, { message: "Uploading", size: "m" }))),
            !isUploading && (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.dropzone({ canDrop: canDrop }), gap: "s", align: "center", justify: "center" },
                react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", gap: "xxs" },
                    react_1.default.createElement(icons_1.Add, { size: icons_1.IconSize.Small, color: "default" }),
                    react_1.default.createElement(kaleidoscope_1.Text, { secondary: true, size: "s" }, "Background"))))))));
};
exports.BackgroundAssetBucket = BackgroundAssetBucket;
